import type { ArenaLayout } from './layout-types';

/**
 * Big open fields (Wave 4): wide arenas with landmarks, cover, hazards and
 * (outside finales) turrets. The ship spawns dead-centre, the boss at
 * (0.72, 0.5) — both spots stay clear (harness-checked). Fractions of size.
 */
export const BIG_ARENAS: ReadonlyArray<ArenaLayout> = [
  {
    // S1 finale: a scrapyard around two derelict reactors
    id: 'scrap-yard',
    nameKey: 'arena.scrap-yard',
    width: 3300,
    height: 2300,
    obstacles: [
      { x: 0.26, y: 0.3, radius: 150, landmark: true },
      { x: 0.74, y: 0.74, radius: 150, landmark: true },
      { x: 0.42, y: 0.2, radius: 60 },
      { x: 0.62, y: 0.22, radius: 55 },
      { x: 0.13, y: 0.62, radius: 65 },
      { x: 0.86, y: 0.36, radius: 60 },
      { x: 0.4, y: 0.8, radius: 60 },
      { x: 0.9, y: 0.12, radius: 70, lava: true },
      { x: 0.1, y: 0.88, radius: 70, lava: true },
    ],
  },
  {
    // S1 regular: a foundry floor — slag channels and gun nests
    id: 'scrap-foundry',
    nameKey: 'arena.scrap-foundry',
    width: 3300,
    height: 2200,
    obstacles: [
      { x: 0.3, y: 0.25, radius: 70 },
      { x: 0.3, y: 0.75, radius: 70 },
      { x: 0.55, y: 0.18, radius: 60 },
      { x: 0.55, y: 0.82, radius: 60 },
      { x: 0.16, y: 0.5, radius: 80, lava: true },
      { x: 0.84, y: 0.2, radius: 75, lava: true },
      { x: 0.84, y: 0.8, radius: 75, lava: true },
    ],
    turrets: [{ x: 0.3, y: 0.12 }, { x: 0.3, y: 0.88 }],
  },
  {
    // S2 finale: a forge between two crystal spires and lava rivers
    id: 'core-forge',
    nameKey: 'arena.core-forge',
    width: 3300,
    height: 2200,
    obstacles: [
      { x: 0.3, y: 0.24, radius: 125, landmark: true },
      { x: 0.7, y: 0.78, radius: 125, landmark: true },
      { x: 0.16, y: 0.74, radius: 90, lava: true },
      { x: 0.25, y: 0.84, radius: 80, lava: true },
      { x: 0.84, y: 0.26, radius: 90, lava: true },
      { x: 0.75, y: 0.16, radius: 80, lava: true },
      { x: 0.5, y: 0.2, radius: 60 },
      { x: 0.5, y: 0.8, radius: 60 },
      { x: 0.36, y: 0.52, radius: 55 },
    ],
  },
  {
    // S3 finale: the nest — egg mounds, sinkholes and acid
    id: 'brood-nest',
    nameKey: 'arena.brood-nest',
    width: 3200,
    height: 2350,
    obstacles: [
      { x: 0.5, y: 0.17, radius: 140, landmark: true },
      { x: 0.5, y: 0.83, radius: 140, landmark: true },
      { x: 0.2, y: 0.34, radius: 90, pit: true },
      { x: 0.2, y: 0.66, radius: 90, pit: true },
      { x: 0.84, y: 0.3, radius: 85, pit: true },
      { x: 0.84, y: 0.7, radius: 85, pit: true },
      { x: 0.34, y: 0.5, radius: 55 },
      { x: 0.66, y: 0.28, radius: 50 },
      { x: 0.33, y: 0.14, radius: 70, lava: true },
      { x: 0.67, y: 0.86, radius: 70, lava: true },
    ],
  },
  {
    // S4 finale: an observatory of monoliths over rift fissures
    id: 'rim-observatory',
    nameKey: 'arena.rim-observatory',
    width: 3300,
    height: 2250,
    obstacles: [
      { x: 0.3, y: 0.22, radius: 100, landmark: true },
      { x: 0.7, y: 0.22, radius: 100, landmark: true },
      { x: 0.3, y: 0.78, radius: 100, landmark: true },
      { x: 0.7, y: 0.78, radius: 100, landmark: true },
      { x: 0.5, y: 0.13, radius: 80, pit: true },
      { x: 0.5, y: 0.87, radius: 80, pit: true },
      { x: 0.1, y: 0.5, radius: 90, lava: true },
      { x: 0.9, y: 0.5, radius: 85, lava: true },
    ],
  },
  {
    // S4 regular: a shard field — scattered crystal cover, rifts, sentries
    id: 'rim-shardfield',
    nameKey: 'arena.rim-shardfield',
    width: 3400,
    height: 2300,
    obstacles: [
      { x: 0.24, y: 0.26, radius: 60 },
      { x: 0.4, y: 0.72, radius: 55 },
      { x: 0.6, y: 0.24, radius: 55 },
      { x: 0.8, y: 0.74, radius: 60 },
      { x: 0.15, y: 0.75, radius: 85, pit: true },
      { x: 0.86, y: 0.22, radius: 85, pit: true },
      { x: 0.5, y: 0.88, radius: 70, lava: true },
    ],
    turrets: [{ x: 0.24, y: 0.5 }, { x: 0.86, y: 0.5 }],
  },
];
